import { useEffect, useState } from 'react';
import { getIssueTypes } from 'src/services/client';

export interface IssueType {
  id?: string;
  name: string;
  value?: string;
  [key: string]: any;
}

interface UseIssueTypesReturn {
  issueTypes: IssueType[];
  isLoading: boolean;
  error: string | null;
}

export const fetchIssueTypesData = async (): Promise<IssueType[]> => {
  const response: any = await getIssueTypes();

  if (!response || (!response.ok && response.status !== 200)) {
    throw new Error('Failed to fetch issue types');
  }

  const responseJson: IssueType[] = await response.json();
  return responseJson ?? [];
};

export const useIssueTypes = (): UseIssueTypesReturn => {
  const [issueTypes, setIssueTypes] = useState<IssueType[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadIssueTypes = async (): Promise<void> => {
      setIsLoading(true);
      setError(null);

      try {
        const result: IssueType[] = await fetchIssueTypesData();
        setIssueTypes(result);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Unknown error');
      } finally {
        setIsLoading(false);
      }
    };

    loadIssueTypes();
  }, []);

  return { issueTypes, isLoading, error };
};

export default useIssueTypes;
